module.exports = __webpack_public_path__ + "static/media/pattern-edit-iconV2.3ad41864.svg";